module.exports = __webpack_public_path__ + "assets/step-1-36392ca5851b70bef33866c51895a667.png";